import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CustomizerMenuPartModel } from '@models/customizer-menu-part';

@Component({
	selector: 'customizer-component-header',
	templateUrl: 'customizer-component-header.html',
	styleUrls: ['./customizer-component-header.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CommonModule, TranslatePipe]
})
export class CustomizerComponentHeaderComponent {

	@Input() menu: CustomizerMenuPartModel;
	@Input() overrideTranslateName: string;
	@Input() className: string;
	@Input() showTranslateDecription?: boolean = true;

	@Output() updateCollapsedOnComponent: EventEmitter<boolean> = new EventEmitter();

	get parentOrMenu(): CustomizerMenuPartModel {
		return this.menu.parentMenu || this.menu;
	}

}
